import { defineStyleConfig } from '@chakra-ui/react';

export const Link = defineStyleConfig({
	baseStyle: {
		textDecoration: 'underline',
		color: 'brandBlue.500'
	}
});
